/* SKINFOUNDRY guide popup — trigger, native customer-form submit, confirmation step.
   Modal after 10s on the page (no scroll trigger, per Joseph 2026-09-27), once per visitor.
   Dismiss and "no thanks" last 30 days. Completing is remembered for this campaign. */
(function () {
  var card = document.getElementById('sfp-card');
  if (!card) return;
  var scrim = document.getElementById('sfp-scrim');
  var form = document.getElementById('sfp-form');

  var STORAGE_PREFIX = 'sfp-freelumis-v1-';
  var DWELL_MS = 10000;
  var SCROLL_PCT = 2; /* scroll trigger off: 2 = never reached */
  var DISMISS_DAYS = 30;
  var forceOpen = /[?&]sfp-open=1/.test(location.search);
  var clearState = /[?&]sfp-reset=1/.test(location.search);

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function lsRemove(k) { try { localStorage.removeItem(k); } catch (e) {} }
  function key(k) { return STORAGE_PREFIX + k; }
  function cleanSearchParam(param) {
    if (!history.replaceState) return;
    var url = new URL(location.href);
    url.searchParams.delete(param);
    history.replaceState(null, '', url.pathname + url.search + url.hash);
  }

  if (clearState) {
    lsRemove(key('done'));
    lsRemove(key('dismissed-at'));
    cleanSearchParam('sfp-reset');
  }

  var done = lsGet(key('done')) === '1';
  var dismissedAt = parseInt(lsGet(key('dismissed-at')) || '0', 10);
  var dismissed = dismissedAt && (Date.now() - dismissedAt) < DISMISS_DAYS * 864e5;
  var opened = false;

  /* success return from Shopify (?sfp-done=1) */
  var justDone = /[?&]sfp-done=1/.test(location.search);
  if (justDone) {
    lsSet(key('done'), '1');
    done = true;
    cleanSearchParam('sfp-done');
  }
  var serverError = form && form.querySelector('[data-sfp-server-error]');

  function setStep(reveal) {
    document.getElementById('sfp-offer').classList.toggle('sfp-hidden', reveal);
    document.getElementById('sfp-reveal').classList.toggle('sfp-hidden', !reveal);
  }
  function openCard(reveal) {
    opened = true;
    scrim.classList.add('sfp-show');
    card.classList.add('sfp-show');
    document.documentElement.classList.add('sfp-lock');
    setStep(!!reveal);
    card.focus({ preventScroll: true });
  }
  function closeCard(remember) {
    scrim.classList.remove('sfp-show');
    card.classList.remove('sfp-show');
    document.documentElement.classList.remove('sfp-lock');
    if (remember && !done) {
      dismissed = true;
      lsSet(key('dismissed-at'), String(Date.now()));
    }
  }

  /* triggers */
  function maybeOpen() {
    if (opened || (!forceOpen && (done || dismissed))) return;
    openCard(false);
  }
  if (forceOpen) {
    cleanSearchParam('sfp-open');
    maybeOpen();
  } else if (!done && !dismissed) {
    setTimeout(maybeOpen, DWELL_MS);
    addEventListener('scroll', function () {
      var d = document.documentElement;
      if (d.scrollHeight > 0 && (scrollY + innerHeight) / d.scrollHeight > SCROLL_PCT) maybeOpen();
    }, { passive: true });
  }

  /* wire controls */
  card.querySelector('[data-sfp-close]').addEventListener('click', function () { closeCard(true); });
  scrim.addEventListener('click', function () { closeCard(true); });
  addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && card.classList.contains('sfp-show')) closeCard(true);
  });

  if (form) {
    form.querySelector('[data-sfp-return]').value = location.pathname + '?sfp-done=1';
    form.addEventListener('submit', function (e) {
      var v = form.querySelector('input[type=email]').value.trim();
      var ok = /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(v);
      document.getElementById('sfp-err').classList.toggle('sfp-show', !ok);
      if (!ok) e.preventDefault();
      /* valid: let the native Shopify customer form post through */
    });
    card.querySelector('[data-sfp-skip]').addEventListener('click', function () {
      closeCard(true);
    });
  }

  /* auto-open states after reload */
  if (justDone) {
    openCard(true);
  } else if (serverError) {
    openCard(false);
    var err = document.getElementById('sfp-err');
    err.textContent = (serverError.textContent || '').trim() || err.textContent;
    err.classList.add('sfp-show');
  }
})();
